import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
	selector: '[numberInput]',
})
export class InputNumberDirective {
	regexStr = /^\d*(\.)?(\d+)?$/;
	constructor(private el: ElementRef) {}

	@HostListener('keypress', ['$event'])
	onKeyPress($event) {
		return new RegExp(this.regexStr).test($event.key);
	}

	@HostListener('paste', ['event'])
	blockPaste(event: ClipboardEvent) {
		return this.validateFields(event);
	}

	validateFields(event: ClipboardEvent) {
		event.preventDefault();
		const pastDate = event.clipboardData.getData('text/plain').replace(/^-?\d*(\.?\d{1,2})?$/, '');
		document.execCommand('insertHTML', false, pastDate);
	}
}
